import { isAxiosError } from 'axios';

const CORRELATION_HEADER = 'x-correlation-id';

const trimString = (value: string): string | undefined => {
  const trimmed = value.trim();
  return trimmed || undefined;
};

const readCorrelationHeader = (
  headers: Record<string, unknown>,
): string | undefined => {
  const raw = headers[CORRELATION_HEADER];
  if (typeof raw === 'string') return trimString(raw);
  if (Array.isArray(raw) && typeof raw[0] === 'string') {
    return trimString(raw[0]);
  }
  return undefined;
};

/**
 * Reads X-Correlation-Id from an Axios error response (axios lowercases headers).
 * Also accepts errors already stamped with `correlationId` by the service interceptor.
 */
export const getCorrelationId = (error: unknown): string | undefined => {
  if (isAxiosError(error) && error.response?.headers) {
    const fromHeader = readCorrelationHeader(
      error.response.headers as Record<string, unknown>,
    );
    if (fromHeader) return fromHeader;
  }

  if (error && typeof error === 'object' && 'correlationId' in error) {
    const stamped = (error as { correlationId?: unknown }).correlationId;
    if (typeof stamped === 'string') return trimString(stamped);
  }

  return undefined;
};

export const stampApiErrorCorrelationId = (
  error: unknown,
  setCorrelationId: (value: string | undefined) => void,
): void => setCorrelationId(getCorrelationId(error));
